import axios from "../config/axios";

export async function obtenerPlanesTrabajo(documento) {
  return await axios.post(
    "/formularios_cuestionarios/formularios/api/v1/obtener_planes_trabajo/paciente",
    {
      documento: Number(documento)
    }
  );
}
